import { Box, Flex, SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { hooks, miscHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';
import { MobileApps, SsoPanel } from 'shared/components';
import { useNewOrgPopupNoCompaniesSave } from 'shared/hooks/useNewOrgPopupNoCompaniesSave';

import { pageConfig } from './config';
import { showLoginModule } from './resources/actions';
import { LoginModule, LoginTwoFaModule } from './resources/components';
import { useAdaptation } from './resources/hooks/useAdaptation';
import { messages } from './resources/messages';
import { PageActiveModule } from './resources/reducers/page/moduleReducer';
import { getLoading, getModule } from './resources/selectors/pageSelectors';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const dispatch = useDispatch();
    const authenticated = storageService.authenticated();
    const module = useSelector(getModule);
    const isLoading = useSelector(getLoading);

    const [postAction] = hooks.useQueryParam('postAction');
    const [app] = hooks.useQueryParam('app');
    const [email] = hooks.useQueryParam('email');

    const { sideSizes, ssoPanelSpacing } = useAdaptation();

    useNewOrgPopupNoCompaniesSave();

    useEffect(() => {
        if (authenticated) {
            if (postAction) {
                routingService.push(postAction);
            } else {
                routingService.replaceToDefaultPath();
            }
        } else {
            dispatch(
                showLoginModule({
                    email,
                    app: miscHelpers.castToEnum(domain.SsoLoginApplication, app),
                    postAction,
                    innerPageId: pageConfig.store.id,
                })
            );
        }
    }, [app, authenticated, dispatch, email, postAction]);

    if (authenticated) return null;

    return (
        <SimpleLayout size='small'>
            <Helmet>
                <title>{messages.title}</title>

                <meta name='description' content={messages.description} />
            </Helmet>

            <SimpleLayout.LeftSide>
                <Box spacing={sideSizes.spacing} width={sideSizes.width} />
            </SimpleLayout.LeftSide>

            <SimpleLayout.Content>
                {module.type === PageActiveModule.LoginModule && <LoginModule />}

                {module.type === PageActiveModule.TwoFaLoginModuleData && (
                    <LoginTwoFaModule
                        app={module.app}
                        stateId={module.stateId}
                        postAction={module.postAction}
                        isTrustThisDeviceEnabled
                        isTFAAlternativeEmailEnabled={module.isTFAAlternativeEmailEnabled}
                        isTFABackupCodesEnabled={module.isTFABackupCodesEnabled}
                    />
                )}
            </SimpleLayout.Content>

            <SimpleLayout.Footer>
                <Box spacing={ssoPanelSpacing}>
                    <SsoPanel
                        variant='login'
                        app={module.app}
                        afterLoginRedirectUrl={module.postAction}
                        disabled={isLoading}
                    />
                </Box>
            </SimpleLayout.Footer>

            <SimpleLayout.RightSide>
                <Flex justifyContent='center'>
                    <Box spacing={sideSizes.spacing} width={sideSizes.width}>
                        <MobileApps />
                    </Box>
                </Flex>
            </SimpleLayout.RightSide>
        </SimpleLayout>
    );
};

export default Page;
